var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBlueReceived(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM18.0518 22.0654L21.4238 25.4375L21.9873 26L25.8945 22.0918L24.208 20.4062L21.9863 22.6279L19.7383 20.3789L18.0518 22.0654ZM7 11.0527V21.1768L15.2939 25.916V25.917L16.3896 23.998L9.20996 19.8945V12.9727L15.0684 16.3555V19.2627L17.2783 20.3672V16.4199L22.4727 13.4199V18.3242H24.6836V11.0518L15.8418 6L7 11.0527ZM21.1943 11.6055L16.2285 14.4727L10.877 11.3838L15.8418 8.54688L21.1943 11.6055Z",
    fill: "#39A2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlueReceived);
export default __webpack_public_path__ + "static/media/icon-blue-received.582d83eb8b316d5462a83d7207b4b24e.svg";
export { ForwardRef as ReactComponent };